import { render } from "./ConflictTemplateModal.vue?vue&type=template&id=5d134fca&scoped=true"
import script from "./ConflictTemplateModal.vue?vue&type=script&lang=js"
export * from "./ConflictTemplateModal.vue?vue&type=script&lang=js"

import "./ConflictTemplateModal.vue?vue&type=style&index=0&id=5d134fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d134fca"]])

export default __exports__